import { GET_REGIONS } from '../actions/types';

const initialState = {
    regions: [],
}

export default function (state = initialState, action) {
    state.errors = [];

    switch (action.type) {
        case GET_REGIONS:
            return {
                ...state,
                regions: action.payload,
            }
        default:
            return state;
    }
}